import React from "react";
import {Router} from "react-router-dom";

import {Provider} from "unstated";
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import * as Sentry from "@sentry/browser";
import {UserContextProvider} from "./contexts/user";
import {DraftContextProvider} from "./contexts/draft";
import {ConfirmContextProvider} from "./contexts/confirm";
import {LoadingContextProvider} from "./contexts/loading";
import App from "./views/App";
import Confirm from "./components/Confirm";
import ReactGA from "react-ga4";
import {createBrowserHistory} from "history";
import "./Root.scss";
import "./toastify.scss";

//import "react-datepicker/dist/react-datepicker.css";

const history = createBrowserHistory();

// Initialize google analytics page view tracking
history.listen(location => {
  ReactGA.set({page: location.pathname}); // Update the user's current page
  ReactGA.send({hitType: "pageview", page: location.pathname}); // Record a pageview for the given page
});

let config;
console.log(`👨‍💻👨‍💻 You're in the ${process.env.REACT_APP_ENV} env 👨‍💻👨‍💻`);
if (process.env.NODE_ENV === "test") {
  config = {
    apiKey: "AIzaSyBp4D3IFqqrXauB0cD9eyNb_QaLn9Rxwzk",
    authDomain: "hackernoon-test.firebaseapp.com",
    databaseURL: "https://hackernoon-test.firebaseio.com",
    projectId: "hackernoon-test",
    storageBucket: "hackernoon-test.appspot.com",
    messagingSpenderId: "653215936717",
  };
} else if (process.env.REACT_APP_ENV === "development") {
  config = {
    apiKey: "AIzaSyCVDCIrU3SXP25fHLQi_JKTU11Qq96iFdw",
    authDomain: "hackernoon-dev.firebaseapp.com",
    databaseURL: "https://hackernoon-dev.firebaseio.com",
    projectId: "hackernoon-dev",
    storageBucket: "hackernoon-dev-ohyeah",
    messagingSenderId: "187734907040",
    appId: "1:187734907040:web:8eb941fc976cba3d",
  };
} else {
  config = {
    apiKey: "AIzaSyCjRAcAgsxlffnuZNIr4zOGaIsEKKEaJCg",
    authDomain: "app.hackernoon.com",
    databaseURL: "https://hackernoon-app.firebaseio.com",
    projectId: "hackernoon-app",
    storageBucket: "hackernoon",
    messagingSenderId: "521962009898",
    measurementId: "G-ECJJ2Q2SJQ",
  };
}

Sentry.init({
  dsn: "https://eabab8fcf7174573b1e1da03794548d7@sentry.io/2610444",
  environment: process.env.REACT_APP_ENVIRONMENT,
  ignoreErrors: ["ResizeObserver loop limit exceeded", "ResizeObserver loop completed with undelivered notifications."], //https://stackoverflow.com/a/50387233/289740
  attachStacktrace: true,
});

firebase.initializeApp(config);
firebase.auth().setPersistence(firebase.auth.Auth.Persistence.NONE);
//firebase.firestore().useEmulator("localhost", 8004);
firebase.firestore().settings({ignoreUndefinedProperties: true, experimentalAutoDetectLongPolling: true, merge: true});

export default function Root(props) {
  return (
    <UserContextProvider>
      <DraftContextProvider>
        <ConfirmContextProvider>
          <LoadingContextProvider>
            <Provider>
              <Router history={history}>
                <div id="root" className="Root">
                  <App />
                </div>
              </Router>
            </Provider>
            <Confirm />
          </LoadingContextProvider>
        </ConfirmContextProvider>
      </DraftContextProvider>
    </UserContextProvider>
  );
}
